/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * OKLCH palette input for one color role. The FE derives the full 50-900 scale, semantic tokens and dark-mode variants from these two numbers (public/theme.js in homemd-web).
 * @export
 * @interface TenantThemeColor
 */
export interface TenantThemeColor {
    /**
     * OKLCH hue in degrees, 0-360.
     * @type {number}
     * @memberof TenantThemeColor
     */
    hue: number;
    /**
     * OKLCH chroma at the 500 strength, 0-0.4.
     * @type {number}
     * @memberof TenantThemeColor
     */
    chroma: number;
}

/**
 * Check if a given object implements the TenantThemeColor interface.
 */
export function instanceOfTenantThemeColor(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "hue" in value;
    isInstance = isInstance && "chroma" in value;

    return isInstance;
}

export function TenantThemeColorFromJSON(json: any): TenantThemeColor {
    return TenantThemeColorFromJSONTyped(json, false);
}

export function TenantThemeColorFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantThemeColor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hue': json['hue'],
        'chroma': json['chroma'],
    };
}

export function TenantThemeColorToJSON(value?: TenantThemeColor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hue': value.hue,
        'chroma': value.chroma,
    };
}

